export const LANGS = [
  { id: "en", label: "English", flag: "us", voice: "en-US", btn: "bg-blue-600", hello: "Hello!", helloColor: "text-blue-700" },
  { id: "es", label: "Español", flag: "es", voice: "es-ES", btn: "bg-red-500", hello: "¡Hola!", helloColor: "text-red-500" },
  { id: "fr", label: "Français", flag: "fr", voice: "fr-FR", btn: "bg-blue-500", hello: "Bonjour!", helloColor: "text-violet-600" },
  { id: "pt", label: "Português", flag: "br", voice: "pt-BR", btn: "bg-green-600", hello: "Olá!", helloColor: "text-green-600" },
];

export const PINS = [
  { lang: "en", left: "39%", top: "31%" },
  { lang: "es", left: "55%", top: "44%" },
  { lang: "fr", left: "69%", top: "31%" },
  { lang: "pt", left: "48%", top: "63%" },
];

const row = (en, es, fr, pt) => ({ en, es, fr, pt });

export const GREETINGS = [
  row("Hello!", "¡Hola!", "Bonjour !", "Olá!"),
  row("Good morning", "Buenos días", "Bonjour (le matin)", "Bom dia"),
  row("Good night", "Buenas noches", "Bonne nuit", "Boa noite"),
  row("Goodbye", "Adiós", "Au revoir", "Tchau"),
  row("Thank you", "Gracias", "Merci", "Obrigado / Obrigada"),
  row("Please", "Por favor", "S'il te plaît", "Por favor"),
  row("How are you?", "¿Cómo estás?", "Comment ça va ?", "Como você está?"),
  row("My name is...", "Me llamo...", "Je m'appelle...", "Meu nome é..."),
];

export const PHRASES = [
  row("I like to play", "Me gusta jugar", "J'aime jouer", "Eu gosto de brincar"),
  row("Can I play with you?", "¿Puedo jugar contigo?", "Je peux jouer avec toi ?", "Posso brincar com você?"),
  row("I'm hungry", "Tengo hambre", "J'ai faim", "Estou com fome"),
  row("Where is the bathroom?", "¿Dónde está el baño?", "Où sont les toilettes ?", "Onde fica o banheiro?"),
  row("I don't understand", "No entiendo", "Je ne comprends pas", "Eu não entendo"),
  row("Let's go!", "¡Vamos!", "On y va !", "Vamos!"),
];

export const VOCAB = [
  { id: "apple", ...row("Apple", "Manzana", "Pomme", "Maçã") },
  { id: "dog", ...row("Dog", "Perro", "Chien", "Cachorro") },
  { id: "cat", ...row("Cat", "Gato", "Chat", "Gato") },
  { id: "house", ...row("House", "Casa", "Maison", "Casa") },
  { id: "sun", ...row("Sun", "Sol", "Soleil", "Sol") },
  { id: "book", ...row("Book", "Libro", "Livre", "Livro") },
  { id: "ball", ...row("Ball", "Pelota", "Ballon", "Bola") },
  { id: "car", ...row("Car", "Carro", "Voiture", "Carro") },
];

export const ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
export const EXTRA_LETTERS = { en: [], es: ["Ñ", "LL", "CH"], fr: ["É", "È", "À", "Ç"], pt: ["Ç", "Ã", "Õ", "É"] };

export const LANG_TEXT = {
  es: {
    titleA: "¡Viaja por el mundo", titleB: "con los idiomas!",
    greet: "Saludos básicos", abc: "Letras y abecedario", phrases: "Frases útiles", vocab: "Palabras con imágenes",
    change: "Cambia el idioma cuando quieras", learning: "Estás aprendiendo", tapListen: "Toca para escuchar",
    extras: "Letras especiales", tapMap: "Toca un país en el mapa", who: "¿Quién te enseña?",
  },
  en: {
    titleA: "Travel the world", titleB: "with languages!",
    greet: "Basic greetings", abc: "Letters & alphabet", phrases: "Useful phrases", vocab: "Words with pictures",
    change: "Switch language anytime", learning: "You're learning", tapListen: "Tap to listen",
    extras: "Special letters", tapMap: "Tap a country on the map", who: "Who teaches you?",
  },
};

export const flagUrl = (code) => `https://flagcdn.com/w80/${code}.png`;
